import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

function Payment({location}) {
  const { token } = useParams();
  const { goBack } = location?.state
  const history = useHistory();

  // console.log('asasa', token)

  useEffect(() => {
    if (token) {
      window?.snap?.pay(token, {
        onSuccess: function (result) {
          // console.log("success", result);
          // console.log(result);
        },
        onPending: function (result) {
          // console.log("pending", result);
          //push with id user because not children
          history.push(goBack)
        },
        onError: function (result) {
          console.log("error");
          history.push(goBack);
        },
        onClose: function () {
          console.log(
            "customer closed the popup without finishing the payment"
          );
          history.push(goBack);
        },
      });
    }
  }, [history, token, goBack]);

  return null
}
export default Payment;